import { useState } from "react";
import { Popover, Whisper } from "rsuite";

interface YearPickerProps {
  selectedYear: number;
  handleYearChange: (year: number) => void;
}

const YEARS: Array<number> = (() => {
  const years = [];
  for (let i = new Date().getFullYear(); i >= 1900; i--) {
    years.push(i);
  }
  return years;
})();

const YearPicker = ({ selectedYear, handleYearChange }: YearPickerProps) => {
  const yearOptions = (
    <>
      {YEARS.map((year) => (
        <Option key={year} year={year} handleYearChange={handleYearChange} />
      ))}
    </>
  );

  return (
    <Whisper
      trigger="click"
      placement="bottom"
      preventOverflow
      speaker={
        <Popover className="year-picker p-0">
          <div
            className="p-0 m-0"
            style={{ height: "200px", width: "70px", overflow: "auto" }}
          >
            {yearOptions}
          </div>
        </Popover>
      }
    >
      <div className="border border-light rounded px-2 py-0 cursor-pointer d-flex align-items-center">
        <p className="m-0">{selectedYear}</p>
        <i className="mdi mdi-calendar ml-3 p-0 text-primary" />
      </div>
    </Whisper>
  );
};

const Option = ({ year, handleYearChange }: any) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      key={year}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => handleYearChange(year)}
      className={`p-1 cursor-pointer text-sm w-100 text-center ${
        hovered ? "bg-lighter" : ""
      }`}
      autoFocus={year === new Date().getFullYear()}
    >
      {year}
    </div>
  );
};
export default YearPicker;
